export default "__VITE_ASSET__B4te8C5H__"